import React from "react";
import { FaArrowLeft } from "react-icons/fa";

/**
 * The screen-header back control.
 *
 * NOTE: a new shared component because the exact same markup — icon, padding,
 * hover and dark-mode classes — had been copied into three feedback screens,
 * and the app's `BreadCrumb` component is not a substitute (it renders plain
 * `<a href>` anchors that full-reload the SPA, which is why only two pages
 * still use it). Navigation stays with the caller; this is presentation only.
 */
export interface BackButtonProps {
  onClick: () => void;
  /** Accessible name — say where it goes, e.g. "Back to feedback". */
  label: string;
  className?: string;
  size?: number;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, label, className = "", size = 14 }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={label}
    title={label}
    className={`shrink-0 rounded-lg p-1.5 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-200 ${className}`}
  >
    <FaArrowLeft size={size} />
  </button>
);

export default BackButton;
